module.exports = __webpack_public_path__ + "static/img/actor-not-found_white-1.da15760.png";